// extracted by mini-css-extract-plugin
module.exports = {"title":"ClientLandingPage_title__1KljX","buttonContainer":"ClientLandingPage_buttonContainer__21hqX"};